import { legacyResaleRedirect } from '~/utils/resale/legacyRedirect';

// In-app navigation to an old /24sold link (full loads are 301'd by server/middleware).
export default defineNuxtRouteMiddleware((to) => {
  const target = legacyResaleRedirect(to.fullPath);
  if (target) return navigateTo(target, { replace: true, redirectCode: 301 });
});
